module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAAXNSR0IB2cksfwAAACFQTFRFAAAA////////////////////////////////////////zyHr+QAAAAt0Uk5TAGiAQDh3YCA/N3BHfl1DAAAAOUlEQVR4nGMQUlJSUmZwApKqDEBCSY3BCETRhG2WlpaWzlAGJJMZcAGPjo6OdoYKINlJc/cg/K4FAIcmIjBOXcP/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--apps-unselected.png
// module id = 925
// module chunks = 0